import '../../campaign-editor/CampaignEditor/campaign_editor.scss';

import { bool, func, string } from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

import CampaignForm from '../../campaign-editor/CampaignForm';
import CampaignHeader from '../../campaign-editor/CampaignHeader/CampaignHeader.container';
import ConnectedCampaignLineFilters from '../../campaign-editor/CampaignLineFilters';
import CampaignLinesTableHeader from '../../campaign-editor/CampaignLinesTableHeader.container';
import CampaignLineStatusBar from '../../campaign-editor/CampaignLineStatusBar';
import CampaignLineTable from '../../campaign-editor/CampaignLineTable';
import CategoryContext from '../../generic/CategorySelect/CategoryContext';
import DiscardableForm from '../../generic/DiscardableForm';
import { billableBudgetShape, campaignShape } from '../../prop-types';

function ProjectCampaignEditor({
  model,
  onChange,
  refreshCampaignLineCreatives,
  isChangeRequestAllowed,
  view,
  isEditing,
  billableBudgets,
  isDelayReasonVisible,
  changeDelayReasonVisibility,
  isPushedToCF,
}) {
  return (
    <DiscardableForm className="c-campaign-editor wide-container-fluid">
      <div className="sticky-top c-secondary-sticky-navbar pt-3 mt-n3 bg-white">
        <CampaignHeader
          campaign={model}
          isChangeRequestAllowed={isChangeRequestAllowed}
          onCreativeModalClose={refreshCampaignLineCreatives}
          view={view}
        />
        <CampaignLineStatusBar />
      </div>
      <div className="mb-4">
        <CampaignForm
          model={model}
          onChange={onChange}
          isEditing={isEditing}
          billableBudgets={billableBudgets}
          isDelayReasonVisible={isDelayReasonVisible}
          changeDelayReasonVisibility={changeDelayReasonVisibility}
          isPushedToCF={isPushedToCF}
        />
      </div>
      {isEditing ? (
        <>
          <div className="py-2 bg-white sticky-top c-campaign-sticky-level-2">
            <Row className="mb-2">
              <Col sm={12}>
                <CategoryContext.Consumer>
                  {categories => (
                    <ConnectedCampaignLineFilters
                      allCategories={categories}
                      isEditing={isEditing}
                    />
                  )}
                </CategoryContext.Consumer>
              </Col>
            </Row>
            <Row>
              <Col>
                <CampaignLinesTableHeader campaignId={model.id} />
              </Col>
            </Row>
          </div>
          <CampaignLineTable
            campaignLines={model.campaignLines}
            onChange={onChange}
            isEditing={isEditing}
          />
        </>
      ) : (
        <h6>
          Please click on Edit to view the campaign lines associated with this
          Campaign.
        </h6>
      )}
    </DiscardableForm>
  );
}

ProjectCampaignEditor.propTypes = {
  model: campaignShape.isRequired,
  onChange: func,
  refreshCampaignLineCreatives: func.isRequired,
  isChangeRequestAllowed: bool.isRequired,
  view: string.isRequired,
  isEditing: bool.isRequired,
  billableBudgets: billableBudgetShape.isRequired,
  isDelayReasonVisible: bool.isRequired,
  changeDelayReasonVisibility: func,
  isPushedToCF: bool.isRequired,
};

ProjectCampaignEditor.defaultProps = {
  onChange: undefined,
  changeDelayReasonVisibility: undefined,
};

export default ProjectCampaignEditor;
